export default __webpack_public_path__ + "assets/7dd7550299ee8cd18e9552734fc602d7.png";